import React, {memo} from "react";
import useFileUploader from "./useFileUploader";
import {FileUploadResp} from "shared/types/common";

const FileUploader = ({ currFileLen, currFileName, handleDownloadFn, handleUploadFn, reUploadMessage, setCurrFileLen, setCurrFileName }: { handleUploadFn: (fl: File) => Promise<FileUploadResp>, handleDownloadFn: (() => Promise<boolean>) | null, currFileName: string, setCurrFileName: React.Dispatch<React.SetStateAction<string>>, currFileLen: number, setCurrFileLen: React.Dispatch<React.SetStateAction<number>>, reUploadMessage: string }) => {
    const {
        status,
        inputRef,
        file,
        displayLabel,
        handleFileSelect,
        handleUpload,
    } = useFileUploader(handleUploadFn, currFileName, setCurrFileName, currFileLen, setCurrFileLen, reUploadMessage);

    const displayStyle: React.CSSProperties = {
        flexGrow: 1, border: `1px solid ${status === 'error' ? 'red' : '#ccc'}`, padding: '5px 8px',
        marginRight: '8px', borderRadius: '4px', cursor: status !== 'uploading' ? 'pointer' : 'default',
        overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '14px',
        backgroundColor: '#f9f9f9', color: status === 'error' ? 'red' : 'inherit',
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}
             onDrop={(e) => { e.preventDefault(); handleFileSelect(e.dataTransfer.files?.[0] ?? null); }}
             onDragOver={(e) => e.preventDefault()} >

            <input type="file" ref={inputRef} style={{ display: 'none' }} accept=".csv, .xlsx, .parquet"
                   onChange={(e) => { handleFileSelect(e.target.files?.[0] ?? null); if(e.target) e.target.value = ''; }}
                   disabled={status === 'uploading'} />

            <div style={displayStyle} title={displayLabel}
                 onClick={() => status !== 'uploading' && inputRef.current?.click()}>
                {displayLabel}
            </div>

            <button type="button" onClick={handleUpload} className="button green-button" style={{flexShrink: 0}}
                    disabled={!file || status === 'uploading'}>
                {status === 'uploading' ? '...' : 'Upload'}
            </button>

            { currFileLen !== 0 && handleDownloadFn !== null?
                <button type="button"
                        onClick={handleDownloadFn}
                        className="button green-button" style={{flexShrink: 0}}
                        disabled={status === 'uploading'}>
                    {status === 'uploading' ? '...' : 'Download'}
                </button> : <></>
            }
        </div>
    );
};

export default memo(FileUploader);
